import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import TermsList from 'components/TermsList';
import Pagination from 'components/Pagination';
import Search from 'components/Search';

import { withData } from 'lib';
import { SettingsTermListPageQuery } from '__generated__/SettingsTermListPageQuery.graphql';

const query = graphql`
  query SettingsTermListPageQuery($first: Int!) {
    ...TermsList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsTermListPageQuery>;
};

const SettingsTermListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsTermListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Įskaičiuota/neįskaičiuota į kainą' },
      ]}>
      <Pagination>
        <Search>
          <TermsList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<SettingsTermListPageQuery>({
  query,
})(SettingsTermListPage);
